<div class="footer">
  <p>{{"@Copyright"}} Versión {{version}}</p>
</div>
